<script lang="ts" setup></script>

<template>
  <div class="divider" />
</template>

<style lang="scss" scoped>
@import 'divider';
</style>
